var _rect, _g, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 50,
    width: 50,
    height: 50,
    rx: 10,
    transform: "rotate(-90 0.5 50)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_772_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1642 14.88C30.7883 14.9027 31.4019 15.0483 31.9698 15.3083C32.5377 15.5683 33.0488 15.9377 33.4738 16.3954C33.8988 16.8531 34.2294 17.3901 34.4467 17.9757C34.664 18.5612 34.7637 19.1839 34.7402 19.808C34.7117 20.2122 34.6038 20.6069 34.4226 20.9693C34.2414 21.3317 33.9904 21.6548 33.6842 21.92L28.8442 26.848C27.7882 27.816 26.7322 28.872 25.7642 29.9281C24.5259 31.1749 22.8566 31.8993 21.1002 31.952L18.5482 32.128H18.0202C17.6682 32.04 17.4042 31.776 17.4922 31.424C17.4817 29.95 17.5995 28.4777 17.8442 27.024C18.1359 25.8999 18.7116 24.8696 19.5162 24.032L27.7882 15.848C28.0836 15.5155 28.4515 15.2553 28.8635 15.0874C29.2754 14.9196 29.7204 14.8486 30.1642 14.88ZM30.5162 22.888H30.3402C29.1962 21.744 28.0522 20.512 26.8202 19.368H26.5562L20.7482 25.088L20.4842 25.352C20.3082 25.528 20.3962 25.616 20.4842 25.704L23.7402 28.96C24.0922 29.312 24.0922 29.312 24.4442 28.96L30.3402 23.064L30.5162 22.888ZM33.1562 19.456C33.1081 18.786 32.8539 18.1473 32.4285 17.6274C32.0031 17.1075 31.4274 16.7319 30.7802 16.552C30.4276 16.437 30.0495 16.4256 29.6907 16.5192C29.3319 16.6128 29.0075 16.8074 28.7562 17.08L27.9642 17.872C27.8762 17.96 27.7882 18.048 27.9642 18.136L31.4842 21.744C31.5722 21.832 31.6602 21.744 31.7482 21.656L32.6282 20.776C32.8031 20.6048 32.9405 20.399 33.0314 20.1717C33.1223 19.9444 33.1648 19.7007 33.1562 19.456ZM22.5082 30.104L19.5162 27.112C19.2345 28.1748 19.0866 29.2686 19.0762 30.368C19.0762 30.456 19.1642 30.456 19.2522 30.456H20.5722C21.2319 30.4403 21.8851 30.3215 22.5082 30.104Z",
    fill: "#0074D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5001 35.12H15.8201C15.7011 35.1342 15.5805 35.1212 15.4673 35.0819C15.3541 35.0427 15.2513 34.9783 15.1665 34.8936C15.0818 34.8089 15.0174 34.706 14.9782 34.5928C14.939 34.4796 14.926 34.359 14.9401 34.24C14.9388 34.0676 15.0007 33.9007 15.1143 33.7709C15.2278 33.6412 15.385 33.5576 15.5561 33.536H35.0921C35.2149 33.5237 35.3388 33.5373 35.456 33.576C35.5731 33.6146 35.6808 33.6775 35.7721 33.7605C35.8634 33.8434 35.9362 33.9447 35.9858 34.0576C36.0354 34.1706 36.0607 34.2927 36.0601 34.416C36.0601 34.768 35.7081 35.032 35.3561 35.12H25.5001Z",
    fill: "#0074D9"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 49.5,
    width: 49,
    height: 49,
    rx: 9.5,
    transform: "rotate(-90 1 49.5)",
    stroke: "#0074D9",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_772_301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(14.5 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/Edit_icon.1dab8a1ffa346cc185f812a43aea4553.svg";
export { ForwardRef as ReactComponent };